export default __webpack_public_path__ + "static/media/2.657012f9.jpg";